<modal-dialog detailDialog #modalDeleteNovelty okText="Cerrar" [closeAccept]="false">
  <!-- Mensajes -->
   @if (message.show) {
     <div class="col-sm-12">
      <div class="alert alert-{{message.type}}">
        <div>
          <span>{{ message.body }}</span>
          <button type="button" class="close" (click)="clearMessage()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
   }

  <div class="col-md-12">
    <div class="text-center">
      <img src="../../assets/common/header/logo-randstad.png" alt="Randstad" width="200px">
    </div>
    <h3 class="text-center mt-2">Tenemos las siguiente novedades para ti. Entra y consúltalas</h3>
  </div>
  <div class="col-md-12 mt-2">
    <loading-overlay [show]="loading" style="width: 100%;">
      <table class="table table-randstad table-bordered table-hover">
        <tbody>
          @if (novelties) {
            @for (novelty of novelties; track $index) {
              <tr>
                <td class="text-start" width="75%">{{ novelty.title }}</td>
                <td>
                  @if (novelty.url) {
                    <a href="{{ novelty.url }}" target="_blank" class="btn btn-xs btn-primary">Ver
                      video</a>
                  }
                  <span class="ms-2"></span>
                  @if (novelty.attachedName) {
                    <a routerLink="" class="btn btn-xs btn-secondary"
                    (click)="downloadAttachment(novelty.noveltyId)">Ver adjunto</a>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </loading-overlay>
  </div>
</modal-dialog>
